<template>
  <ValidationObserver rules="required" v-slot="{ handleSubmit }">
    <RightSideBar
      v-if="openModal"
      :loading="loading"
      @submit="handleSubmit(submit)"
      submit="Apply"
      @close="handleClose"
      button-class="bg-dynamicBackBtn text-white"
      width="width:520px"
    >
      <template v-slot:title>
        <p class="text-darkPurple">
          New Payrun
        </p>
      </template>
      <div>
        <div class="">
          <c-select
            placeholder="--Select--"
            v-model="variableMonth"
            :options="month"
            :rules="['required']"
            :disabled="!isSetup"
            variant="w-full"
            label="Payrun Cycle"
          />
        </div>
          <alert
            message='Do you want to run previous month(s) pay run? Go to "Back Pay" and click "New Pay Run" to access previous month(s).'
            variant="primary"
            :time="2"
            style="
              position: relative;
              right: 0;
              top: 14px;
              border: 1px solid #e99323;
              box-shadow: none;
              background: rgba(244, 213, 176, 0.15);
              color: black;
            "
          />
        <div class="mt-8">
          <p class="mb-3  font-bold">Pay Type</p>
          <radio-button
            :options="payTypeOptions"
            col-span="col-span-6"
            class=" inline-block ml-2 text-jet"
            v-model="payRunFilter.payType"
            @input="getPayFrequencySetup($event)"
          />
        </div>
        <div class="mt-5 ">
          <p class="mb-3 text-base text-jet">Pay Frequency</p>
          <radio-button
            :options="payFrequencyOptions"
            col-span="col-span-12"
            @input="handleFrequencyChange"
            class="inline-block text-jet ml-2"
            v-model="payRunFilter.payFrequency"
            v-if="payFrequencyOptions.length"
          />
          <div v-else>
            <small v-if="salariedIsSetup || hourlyIsSetup" class="text-flame font-bold">
              Please select a pay type to see available pay frequencies
            </small>
            <small v-else class="text-flame font-bold">
              You do not have any pay frequency setup
            </small>
          </div>
        </div>
        <div v-if="payRunFilter.payFrequency !== 'monthly'" class="mt-5">
          <c-select
            placeholder="--Select--"
            v-model="splitPosition"
            :options="positions"
            variant="w-full"
            label="Payment"
          />
        </div>
        <accordion show-divider>
          <template v-slot:title>
            <p class="font-semibold text-flame text-xs uppercase">
              Filter By
            </p>
          </template>
          <div
            class="grid grid-cols-12 gap-4 text-darkPurple"
            style="margin-top:1.125rem"
          >
            <div class="col-span-12">
              <div class="col-span-3">
                <v-select
                  :clearable="false"
                  placeholder="Search employees"
                  label="fname"
                  class="style-select"
                  :reduce="option => option.id"
                  v-model="search"
                  multiple
                  @search="setAllOrgUsers"
                  :options="allOrgUsers"
                  :filterable="false"
                >
                  <template
                    #option="{fname, lname, orgFunction, userDesignation, photo }"
                  >
                    <div class="flex">
                      <span class="mt-2 ">
                        <img
                          class=""
                          :src="photo"
                          v-if="photo"
                          alt="profile pic"
                          style="height: 25px; width: 25px; border-radius: 5px;"
                        />
                        <div
                          style="height: 25px; width: 25px; border-radius: 5px;"
                          class="text-blueCrayola text-xs border text-center font-semibold pt-1"
                          v-else
                        >
                          {{ $getInitials(`${fname} ${lname}`) }}
                        </div>
                      </span>
                      <div class="ml-2 hover:text-white">
                        <div class="font-bold mt-1 text-sm cursor-pointer">
                          {{ fname }} {{ lname }}
                        </div>
                        <div class=" " style="font-size: 10px">
                          <span class="uppercase">{{
                            orgFunction ? orgFunction.name : ""
                          }}</span>
                          <span class="ml-2">{{
                            userDesignation ? `${userDesignation.name}` : ""
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #selected-option="{fname, lname}">
                    {{ fname }} {{ lname }}
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes">
                      <icon icon-name="caret-down" size="xsm" />
                    </span>
                  </template>
                  <template #list-footer>
                    <li style="text-align: center; font-size: 12px">
                      Type name of employee to search more
                    </li>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="col-span-12">
              <c-select
                placeholder="--Select--"
                :options="locationData"
                :disabled="search.length > 0"
                @input="check($event, locationData, locationTags)"
                label="Location(s)"
                variant="w-full"
              />
              <div class="flex flex-wrap">
                <div
                  class="flex justify-between p-2 mt-3 mr-2"
                  v-for="(tag, index) in locationTags"
                  :key="index"
                  style="background: #F7F7FF;border-radius: 5px;"
                >
                  <p class="mr-2">
                    {{ tag.name }}
                  </p>
                  <div
                    @click="locationTags.splice(index, 1)"
                    class="cursor-pointer mt-2"
                  >
                    <icon icon-name="close" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-span-12">
              <c-select
                placeholder="--Select--"
                :options="filteredFunctions"
                :disabled="search.length > 0"
                @input="
                  check($event, filteredFunctions, functionTags),
                    functionIds.push($event.toString())
                "
                label="Function(s)"
                variant="w-full"
              />
              <div class="flex flex-wrap">
                <div
                  class="flex justify-between p-2 mt-3 mr-2"
                  v-for="(tag, index) in functionTags"
                  :key="index"
                  style="background: #F7F7FF;border-radius: 5px;"
                >
                  <p class="mr-2">
                    {{ tag.name }}
                  </p>
                  <div
                    @click="
                      functionTags.splice(index, 1),
                        functionIds.splice(index, 1)
                    "
                    class="cursor-pointer mt-2"
                  >
                    <icon icon-name="close" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-span-12">
              <c-select
                placeholder="--Select--"
                :options="setDesignation"
                :disabled="search.length > 0"
                @input="
                  check($event, setDesignation, designationTags),
                    designationIds.push($event.toString())
                "
                label="Designation(s)"
                variant="w-full"
              />
              <div class="flex flex-wrap">
                <div
                  class="flex justify-between p-2 mt-3 mr-2"
                  v-for="(tag, index) in designationTags"
                  :key="index"
                  style="background: #F7F7FF;border-radius: 5px;"
                >
                  <p class="mr-2">
                    {{ tag.name }}
                  </p>
                  <div
                    @click="
                      designationTags.splice(index, 1),
                        designationIds.splice(index, 1)
                    "
                    class="cursor-pointer mt-2"
                  >
                    <icon icon-name="close" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-span-12">
              <c-select
                placeholder="--Select--"
                :options="setLevel"
                :disabled="search.length > 0"
                @input="check($event, setLevel, levelTags)"
                label="Job Level(s)"
                variant="w-full"
              />
              <div class="flex flex-wrap">
                <div
                  class="flex justify-between p-2 mt-3 mr-2"
                  v-for="(tag, index) in levelTags"
                  :key="index"
                  style="background: #F7F7FF;border-radius: 5px;"
                >
                  <p class="mr-2">
                    {{ tag.name }}
                  </p>
                  <div
                    @click="levelTags.splice(index, 1)"
                    class="cursor-pointer mt-2"
                  >
                    <icon icon-name="close" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-span-12">
              <c-select
                placeholder="--Select--"
                :options="employmentTypesArray"
                v-model="employmentType"
                label="Employment Type"
                variant="w-full"
              />
            </div>
          </div>
        </accordion>
      </div>
    </RightSideBar>
  </ValidationObserver>
</template>

<script>
import { clone } from "lodash";
import { ValidationObserver } from "vee-validate";
import "vue-select/dist/vue-select.css";
import Alert from "@scelloo/cloudenly-ui/src/components/alert";

export default {
  name: "FilterPayrun",
  components: {
    ValidationObserver,
    Alert,
    vSelect: () => import("vue-select"),
    RightSideBar: () => import("@/components/RightSideBar"),
    Accordion: () => import("@/components/Accordion"),
    CSelect: () => import("@scelloo/cloudenly-ui/src/components/select"),
    RadioButton: () => import("@/components/RadioButton")
  },
  props: {
    openModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      suspensionReasons: [],
      isExisitingReason: false,
      today: new Date(),
      isSetup: null,
      month: [],
      variableMonth: "",
      search: "",
      positions: [],
      salariedIsSetup: false,
      hourlyIsSetup: false,
      splitPosition: "",
      locationData: [],
      locationTags: [],
      functionData: [],
      functionTags: [],
      levelData: [],
      levelTags: [],
      functionIds: [],
      designationIds: [],
      designationData: [],
      designationTags: [],
      des: [],
      payRunFilter: {
        effectiveDate: null,
        payType: null,
        payFrequency: null,
        locationIds: [],
        functionIds: [],
        levelIds: [],
        designationIds: []
      },
      loading: true,
      payTypeOptions: [
        { name: "Salaried", value: "salaried" }
      ],
      payFrequencyOptions: [],
      allOrgUsers: [],
      employmentTypesArray: [],
      employmentType: "",
      isFetchingFrequency: false
    };
  },
  computed: {
    filteredFunctions() {
      return this.$store.state.org.getAllFunctions;
    },
    setDesignation() {
      const designationArray = [];
      this.$store.state.org.getAllFunctions.forEach(item => {
        if (this.functionIds.includes(item.id)) {
          designationArray.push(...item.designations);
        }
      });
      if (designationArray.length) {
        return designationArray;
      }

      return [];
    },
    setLevel() {
      const result = [];
      if (this.setDesignation) {
        this.setDesignation.forEach(item => {
          if (this.designationIds.includes(item.id)) {
            result.push(item.level);
          }
        });
      }
      return result;
    }
  },
  methods: {
    async setAllOrgUsers(search, loading) {
      loading(true);
      try {
        const attributes = "id,fname,lname,photo,userId";
        const { data } = await this.$_getAllEmployeesWithQueries(
          `search=${search}&perPage=1000&payrollStatus=active&attributes=${attributes}`
        );
        this.allOrgUsers = data.data.employees;
        loading(false);
      } catch (err) {
        throw new Error(err);
      }
    },
    getOrgEmploymentTypes() {
      this.$_getOrgEmploymentTypes().then(({ data }) => {
        this.employmentTypesArray = data.data;
      });
    },
    handleFrequencyChange(value) {
      this.positions = [];
      if (value === "twice_monthly") {
        for (let i = 1; i <= 2; i++) {
          this.positions.push({
            name: `${this.$getOrdinal(i)} Payment`,
            id: i
          });
        }
        return;
      }
      if (value === "weekly") {
        for (let i = 1; i <= 4; i++) {
          this.positions.push({
            name: `${this.$getOrdinal(i)} Payment`,
            id: i
          });
        }
      }
    },
    getMonths() {
      this.$_getPayrunMonths(`?payType=regular`).then(res => {
        this.isSetup = res.data.isSetup;

        this.month = res.data.duration.map(item => ({
          name: item.name,
          id: JSON.stringify({ month: item.month, year: item.year })
        }));
      });
    },
    check(itemValue, itemArry, newArry) {
      const value = itemArry.find(element => element.id === itemValue);
      if (value) {
        const isPresent = newArry.find(element => element.id === value.id);
        if (isPresent) {
          return;
        }
        newArry.push({ name: value.name, id: value.id });
      }
    },
    async getDesignations() {
      try {
        const response = await this.$_getDesignations("");
        this.designationData = clone(response.data.designations);
      } catch (error) {
        throw new Error(error);
      }
    },
    async getLevels() {
      try {
        const response = await this.$_getLevels();
        const { levels } = response.data;

        this.levelData = levels;
        this.loading = false;

        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    handleClose() {
      this.payRunFilter = {
        effectiveDate: null,
        payType: null,
        payFrequency: null,
        locationIds: [],
        functionIds: [],
        levelIds: [],
        designationIds: []
      };
      this.$emit("close");
    },
    getIds(arr) {
      const result = [];
      arr.forEach(item => {
        result.push(item.id);
      });
      return result.join(",");
    },
    submit() {
      if (this.payFrequencyOptions.length === 0) {
        this.$toasted.error("Please select a pay frequency OR set up one", {
          duration: "3000"
        });
        return;
      }
      const ObjDate = JSON.parse(this.variableMonth);
      const arrQuery = {
        month: ObjDate.month,
        year: ObjDate.year,
        payType: this.payRunFilter.payType,
        payFrequency: this.payRunFilter.payFrequency,
        splitPosition: this.splitPosition || 1,
        locationId: this.getIds(this.locationTags),
        functionId: this.getIds(this.functionTags),
        levelId: this.getIds(this.levelTags),
        designationId: this.getIds(this.designationTags),
        employeeId: this.search ? this.search.join(",") : "",
        employmentType: this.employmentType || "",
        type: "regular"
      };
      this.$router.push({ name: "New Payrun", query: arrQuery });
      this.$emit("close");
    },
    formatPayFreqency(frequency) {
      if (frequency === "twice_monthly") {
        return "Twice Monthly";
      }
      if (frequency === "weekly") {
        return "Four Times Monthly";
      }
      if (frequency === "monthly") {
        return "Monthly";
      }
      return frequency;
    },
    getPayFrequencySetup(payType) {
      this.$_getPaySchedulesSetup().then(({ data }) => {
        this.salariedIsSetup = data.salariedIsSetup
        this.hourlyIsSetup = data.hourlyIsSetup

        if (payType && (data.salariedIsSetup || data.hourlyIsSetup)) {
          this.payFrequencyOptions = data[payType]?.map((item) => ({
            name: this.formatPayFreqency(item.name),
            radioName: payType,
            value: item.name
          }))
        }
      }).catch((error) => {
        this.$toasted.error(error, { duration: 5000 })
      })
    }
  },
  watch: {
    async openModal() {
      if (this.openModal) {
        this.loading = true;
        this.getOrgEmploymentTypes();
        this.getPayFrequencySetup();
        await this.getMonths();
        await this.$store.dispatch("org/getFunction");
        await this.getDesignations();
        await this.getLevels();
        const result = await this.$_getHumanarLocations();
        this.locationData = result.data.outlets;
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
